module.exports = __webpack_public_path__ + "img/25_jbt8011_1-1999.prt.0199ce97.jpg";